import { AxiosError } from 'axios';
import { TemporaryLinkService } from 'common/services/temporary-link-service.api';
import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import { actions } from 'store/actions';

import {
  generateTemporaryLinksSlice, GenerateTemporaryLinkState,
} from '../reducers/temporary-links/generate-temporary-links-slice';

type GetPublisherTemporaryLinksActionType = ReturnType<typeof actions.getPublisherTemporaryLinks>;

function* getPublisherTemporaryLinks(action: GetPublisherTemporaryLinksActionType) {
  try {
    const { data } = yield call(
      TemporaryLinkService.getPublisherLinks,
      action.payload.query,
      action.payload.publisherId || undefined,
    );
    yield put(actions.setPublisherTemporaryLinks(data));
  } catch (err) {
    toast.error('Error getting hardcoded links');
    if (err instanceof AxiosError) {
      yield put(actions.setTemporaryLinksError(err));
    }
  }
}

type GenerateTemporaryLinksActionType = ReturnType<typeof generateTemporaryLinksSlice.actions.generate>;

function* generateTemporaryLinksSaga(action: GenerateTemporaryLinksActionType) {
  try {
    const { data } = yield call(
      TemporaryLinkService.generateLink,
      action.payload.payload,
    );

    // todo: need to rethink this moment with product updating
    const links = [
      ...(data as GenerateTemporaryLinkState['links'])?.created || [],
      ...(data as GenerateTemporaryLinkState['links'])?.updated || [],
    ];

    if (links?.length && action?.payload?.meta?.onSuccess) {
      links.forEach((link) => {
        action?.payload?.meta.onSuccess(link.asin, {
          is_hardcoded_link: 1,
          page_url: link.link,
          hardcoded_link_source: action.payload.payload.source,
        });
      });
    }
    yield put(generateTemporaryLinksSlice.actions.success(data));
  } catch (err) {
    let error;
    if (err instanceof AxiosError) {
      error = {
        code: err.response?.status,
        message: err.response?.status === 500 ? 'Failed to generate links' : err.message,
      };
    } else {
      error = {
        code: 500,
        message: 'Failed to generate links',
      };
    }
    yield put(generateTemporaryLinksSlice.actions.error(error));
    toast.error(error?.message);
  }
}

export function* temporaryLinksSagaWatcher() {
  yield takeLatest(actions.getPublisherTemporaryLinks.type, getPublisherTemporaryLinks);
  yield takeLatest(generateTemporaryLinksSlice.actions.generate, generateTemporaryLinksSaga);
}
